// Slick Carousel
import Glide from '@glidejs/glide'

class HomeCarousel {
    constructor() {
        // element that will be wrapped
        const carousel = document.querySelector('.home-carousel');
        if (!carousel) return;

        // Scope queries to the carousel so we do not accidentally grab the wrong node.
        const carouselTrack = carousel.querySelector('.wp-block-group');
        if (!carouselTrack) {
            console.warn('[HomeCarousel] .wp-block-group not found inside .home-carousel');
            return;
        }

        // NOTE: this selector should be relative to the track, not include .home-carousel again.
        const carouselSlides = carouselTrack.querySelector('.wp-block-gallery');
        if (!carouselSlides) {
            console.warn('[HomeCarousel] .wp-block-gallery not found inside .home-carousel .wp-block-group');
            return;
        }

        const carouselIndividualSlide = carouselSlides.querySelectorAll('.wp-block-image');
        if (!carouselIndividualSlide || carouselIndividualSlide.length === 0) {
            console.warn('[HomeCarousel] No .wp-block-image slides found inside .wp-block-gallery');
            return;
        }

        // Avoid re-initialising if the block is rendered twice (e.g. editor previews / partial renders)
        if (carousel.classList.contains('glide')) return;
        carousel.classList.add('glide');

        // Add Glide classes
        carouselTrack.classList.add('glide__track');
        carouselTrack.dataset.glideEl = 'track';
        carouselSlides.classList.add('glide__slides');
        carouselIndividualSlide.forEach((item) => item.classList.add('glide__slide'));

        // Tweak styles
        carousel.style.overflow = 'hidden';
        carouselSlides.style.flexWrap = 'nowrap';

        // Create arrow buttons (only if they do not already exist)
        let arrows = carousel.querySelector('.glide__arrows');
        if (!arrows) {
            arrows = document.createElement('div');
            arrows.className = 'glide__arrows';
            arrows.dataset.glideEl = 'controls';

            const prevButton = document.createElement('button');
            prevButton.className = 'glide__arrow glide__arrow--left';
            prevButton.dataset.glideDir = '<';
            prevButton.type = 'button';
            prevButton.textContent = '<';

            const nextButton = document.createElement('button');
            nextButton.className = 'glide__arrow glide__arrow--right';
            nextButton.dataset.glideDir = '>';
            nextButton.type = 'button';
            nextButton.textContent = '>';

            arrows.appendChild(prevButton);
            arrows.appendChild(nextButton);
            carousel.appendChild(arrows);
        }

        new Glide('.home-carousel', {
            type: 'carousel',
            perView: 1,
            autoplay: 9000,
            peek: 0,
            gap: 0
        }).mount();
    }
}

export default HomeCarousel;
